export default function timesheetRefactorInData(datesData) {
  let refactoredData = {};

  if (Array.isArray(datesData)) {
    let dates = [];
    let clients = {};
    let schedules = {};

    datesData.forEach(({ client, date, fullname, positionname, schedule }) => {
      date = new Date(date).toLocaleDateString();

      if (!dates.includes(date)) {
        dates.push(date);
      }
      clients[client] = {
        fullname,
        positionname,
      };
      if (schedules[client]) {
        schedules[client][date] = schedule;
      } else {
        schedules[client] = { [date]: schedule };
      }
    });

    refactoredData = {
      dates,
      clients,
      schedules,
    };
  }

  return refactoredData;
}
